<a class='sidebar-logo'
     [routerLink]="'/'+item.routerLink"
     [class.sidebar-logo--collapsed]="collapsed" *ngIf='item?.image'>
  <div [class.closed]="collapsed"
       [class.sidebar-logo-full]="enableFullSize"
       [class.sidebar-logo-cropper]="!enableFullSize">
    <img #logo alt=" " [src]='item?.image | async' (error)="logo.src='assets/images/default-logo.png'">
  </div>
</a>

<a class="sidebar-logo-label" [routerLink]="'/'+item.routerLink" *ngIf='!item?.image'>
  <div class="sl-label text-ellipsis">{{ item?.label | async }}</div>
  <div class="sl-label-collapsed" *ngIf="collapsed">{{ item?.label | async }}</div>
</a>
